import type {
  FieldLogFootageLinkLookupItem,
  FieldLogFootageLinkLookupResponse,
} from '@/features/field-log/types/fieldLog';
import { z } from 'zod';

export const FIELD_LOG_ASSET_LINK_BATCH_SIZE = 200;

export const assetFieldLogLinkFormSchema = z.object({ sessionId: z.string().min(1) }).strict();

/** Deduplicates assets and keeps each asset-side reverse lookup within the API limit. */
export function fieldLogAssetLinkBatches(assetIds: readonly string[]): string[][] {
  const ids = [...new Set(assetIds.filter(Boolean))];
  const batches: string[][] = [];
  for (let offset = 0; offset < ids.length; offset += FIELD_LOG_ASSET_LINK_BATCH_SIZE) {
    batches.push(ids.slice(offset, offset + FIELD_LOG_ASSET_LINK_BATCH_SIZE));
  }
  return batches;
}

/** Indexes lookup responses by asset id without treating an absent response as unlinked. */
export function indexFieldLogAssetLinks(
  responses: readonly FieldLogFootageLinkLookupResponse[],
): ReadonlyMap<string, FieldLogFootageLinkLookupItem> {
  return new Map(
    responses.flatMap((response) => response.items.map((item) => [item.assetId, item])),
  );
}
